exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".joyride-beacon__inner{background-color:#336dc2}.joyride-beacon__outer{border-color:#336dc2;background-color:rgba(51,190,194,.2)}.joyride-tooltip__button{padding:9px 16px}.joyride-tooltip__button--secondary{color:#336dc2}.joyride-tooltip__button--skip{padding-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/Joyride/styles.scss
// module id = 1013
// module chunks = 0